<template>
    <validation-observer v-slot="{ invalid, handleSubmit }" ref="feedbackValidator">
        <form @submit.prevent="handleSubmit(submit)" @keydown="errors.clear($event.target.name)">

            <div class="form-group" v-if="session">
                <label class="form-control-label mb-3">{{ $t('feedbacks.recipients') }}</label>

                <base-checkbox class="mb-3" v-if="session.learner1" v-model="value.learner1_check">
                    <session-recipient :session="session" :degree="registration.degree" :learner="1"></session-recipient>
                </base-checkbox>

                <base-checkbox class="mb-3" v-if="session.learner2" v-model="value.learner2_check">
                    <session-recipient :session="session" :degree="registration.degree" :learner="2"></session-recipient>
                </base-checkbox>

                <base-checkbox class="mb-0" v-model="value.personal">
                    {{ $t('feedbacks.recipients-me') }}
                </base-checkbox>
            </div>

            <div class="row" v-if="!value.timeslot_id">
                <time-input class="col-6"
                    :label="$t('logs.from')"
                    v-model="value.log_time_from"
                    name="log_time_from"
                    :error="errors.get('log_time_from')">
                </time-input>

                <time-input class="col-6"
                    :label="$t('logs.to')"
                    v-model="value.log_time_to"
                    name="log_time_to"
                    :error="errors.get('log_time_to')">
                </time-input>
            </div>

            <base-input class="mb-3" v-if="!value.timeslot_id"
                :label="$t('feedbacks.summary')"
                :placeholder="$t('feedbacks.summary')"
                v-model="value.learner_summary"
                name="learner_summary"
                :error="errors.get('learner_summary')">
            </base-input>

            <base-input class="mb-3"
                :label="$t('feedbacks.legend')"
                name="public_description"
                :error="errors.get('public_description')"
            >
                <textarea class="form-control" rows="3"
                    :placeholder="$t('feedbacks.legend')"
                    v-model="value.public_description"
                ></textarea>
            </base-input>

            <base-input class="mb-3" v-if="session"
                :label="$t('feedbacks.instructors-comment')"
                name="confidential_description"
                :error="errors.get('confidential_description')"
            >
                <textarea class="form-control" rows="3"
                    :placeholder="$t('feedbacks.instructors-comment')"
                    v-model="value.confidential_description"
                ></textarea>
            </base-input>

            <base-select class="mb-4" v-if="session"
                :label="$t('common.competencies')"
                :placeholder="$t('common.competencies')"
                v-model="value.competency_ids"
                :options="competencies"
                @input="errors.clear('competencies')"
                :error="errors.get('competencies')"
                color="info"
                :multiple="true"
            >
            </base-select>

            <div class="category form-category mb-4">
                <small><span class="text-warning">*</span> {{ $t('common.required-fields') }}</small>
            </div>

            <div class="text-center">
                <base-button native-type="submit"
                    type="primary"
                    :disabled="errors.any() || invalid"
                >
                    {{ $t('common.update') }}
                </base-button>

                <base-button type="link" class="ml-auto" @click="modal.show = false">
                    {{ $t('common.cancel') }}
                </base-button>
            </div>

        </form>
    </validation-observer>
</template>

<script>
    import SessionRecipient from './SessionRecipient'

    export default {
        
        components: {
            SessionRecipient
        },

        props: {

            value: {
                type: Object,
                required: true
            },

            errors: {
                type: Object,
                required: true
            },

            modal: {
                type: Object,
                required: true
            },

            registration: {
                type: Object,
                required: true
            },

            session: {
                type: Object,
                default: null
            },

            competencies: {
                type: Object,
                required: true
            },
        },

        created() {
            this.errors.setValidator('feedbackValidator', this)
        },

        computed: {

            learner1Check() {
                return this.value.learner1_check
            },

            learner2Check() {
                return this.value.learner2_check
            },

            personal() {
                return this.value.personal
            },
        },

        watch: {

            learner1Check(value) {
                if (!value && !this.learner2Check && !this.personal) {
                    this.$nextTick(() => {
                        this.value.learner1_check = true
                    })
                }
            },

            learner2Check(value) {
                if (!value && !this.learner1Check && !this.personal) {
                    this.$nextTick(() => {
                        this.value.learner2_check = true
                    })
                }
            },

            personal(value) {
                if (!value && !this.learner1Check && !this.learner2Check) {
                    this.$nextTick(() => {
                        this.value.personal = true
                    })
                }
            },
        },

        methods: {

            submit() {
                this.$emit('input', { ...this.value})
            }
        }
    }
</script>
